module.exports = __webpack_public_path__ + "media/img/carQ_ubezpieczenia-4715540a.png";